import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const Layout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="min-h-screen bg-deep text-offwhite flex flex-col">
      <Header />
      <main className={`flex-1 ${pathname === "/" ? "" : "pt-[88px]"}`}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
